import { gql } from 'apollo-angular';

import { articles } from 'article/model/article.fragments';
import { modulePageDocuments } from 'document/model/document.fragments';

import { modulePageGraphs } from './graph/module-graph.fragments';
import { modulePageQuestions } from './question/module-question.fragments';
import { modulePageTasks } from './task/module-task.fragments';

export const modulePages = gql`
	fragment ModulePages on ModulePageOutput {
		id
		type
		position
		updateTimestamp
		articles {
			...Articles
		}
		tasks {
			...ModulePageTasks
		}
		graphs {
			...ModulePageGraphs
		}
		questions {
			...ModulePageQuestions
		}
		documents {
			...ModulePageDocuments
		}
		localizations {
			text
			link
			title
			locale
		}
	}
	${modulePageQuestions}
	${modulePageDocuments}
	${modulePageGraphs}
	${modulePageTasks}
	${articles}
`;
